<template>
	<div>
		<!-- Thematic Selection Card - Show first -->
		<div v-if="!showResults" class="vx-card p-6">
			<h3 class="mb-6">Sélectionner une ou plusieurs thématiques</h3>

			<div class="vx-row">
				<div class="vx-col w-full">
					<vs-select
						v-model="selectedThematics"
						label="Thématiques"
						placeholder="Choisir une ou plusieurs thématiques"
						class="w-full mb-6"
						multiple
						autocomplete
					>
						<vs-select-item
							v-for="cat in categories"
							:key="cat.id"
							:value="cat.id"
							:text="cat.name"
						>
							{{ cat.name }}
						</vs-select-item>
					</vs-select>
				</div>
			</div>

			<!-- Price Range Filters -->
			<div class="vx-row mb-4">
				<div class="vx-col sm:w-1/2 w-full">
					<label class="vs-input--label mb-2">Prix minimum (€)</label>
					<vs-input
						v-model="startPriceFilter"
						type="number"
						placeholder="Ex: 100"
						class="w-full"
					/>
				</div>
				<div class="vx-col sm:w-1/2 w-full">
					<label class="vs-input--label mb-2">Prix maximum (€)</label>
					<vs-input
						v-model="endPriceFilter"
						type="number"
						placeholder="Ex: 500"
						class="w-full"
					/>
				</div>
			</div>

			<!-- Countries Selection -->
			<div class="vx-row mb-4">
				<div class="vx-col w-full">
					<vs-select
						v-model="selectedCountries"
						label="Pays"
						placeholder="Choisir un ou plusieurs pays"
						class="w-full"
						multiple
						autocomplete
					>
						<vs-select-item
							v-for="country in countries"
							:key="country.name"
							:value="country.name"
							:text="country.name"
						>
							{{ country.name }}
						</vs-select-item>
					</vs-select>
				</div>
			</div>

			<div class="flex justify-end">
				<vs-button
					color="primary"
					type="filled"
					:disabled="!selectedThematics || selectedThematics.length === 0"
					@click="searchWithThematic"
				>
					<vs-icon icon="search" class="mr-2"></vs-icon>
					Rechercher
				</vs-button>
			</div>
		</div>

		<!-- Results Section - Show after search -->
		<div v-if="showResults">
			<!-- Selected Thematic Display -->
			<!-- <div class="vx-card p-4 mb-4">
				<div class="flex items-center justify-between">
					<div>
						<div class="flex items-center flex-wrap mb-2">
							<strong class="mr-2">Thématiques sélectionnées:</strong>
							<vs-chip
								v-for="thematic in selectedThematics"
								:key="thematic"
								color="primary"
								class="mr-2 mb-1"
							>
								{{ getThematicName(thematic) }}
							</vs-chip>
						</div>
						<div
							v-if="startPriceFilter || endPriceFilter"
							class="flex items-center flex-wrap"
						>
							<strong class="mr-2">Fourchette de prix:</strong>
							<vs-chip color="success" class="mr-2">
								{{ startPriceFilter || "0" }}€ - {{ endPriceFilter || "∞" }}€
							</vs-chip>
						</div>
					</div>
				</div>
			</div> -->

			<!-- Filter Card with existing filters + Advanced Filters -->
			<div class="backlinks-filter-wrapper">
				<FilterCard
					:refreshKey="1"
					:key="filterRefreshKey"
					:isOpen="true"
					:showListLength="dataList.length"
					:filters="filtersTemplates"
					@action="handleFilterEmits($event)"
					@filter="handleFilterEmits($event)"
					:actions="actionsTemplates"
					:onChangeEmit="true"
					@clearAll="resetAllFilter()"
					:showRowNum="false"
				/>
				<div class="advanced-filters-bar">
					<span
						class="advanced-filters-toggle"
						@click="showAdvancedFilters = !showAdvancedFilters"
					>
						Filtres avancés
						<feather-icon
							:icon="showAdvancedFilters ? 'ChevronUpIcon' : 'ChevronDownIcon'"
							svgClasses="h-3 w-3 ml-1"
						/>
					</span>
				</div>
				<transition name="advanced-filters-slide">
					<div v-if="showAdvancedFilters" class="advanced-filters-panel">
						<div class="flex justify-end mb-2">
							<feather-icon
								icon="XIcon"
								svgClasses="h-4 w-4 cursor-pointer text-grey"
								@click="closeAdvancedFilters"
							/>
						</div>
						<div class="advanced-sorts-row">
							<div class="advanced-sort-col">
								<label class="advanced-sort-label">TF</label>
								<select v-model="advancedSorts.tf" class="advanced-sort-select" @change="onSortChange('tf')">
									<option v-for="opt in sortOptions" :key="'tf-' + opt.value" :value="opt.value">{{ opt.label }}</option>
								</select>
							</div>
							<div class="advanced-sort-col">
								<label class="advanced-sort-label">CF</label>
								<select v-model="advancedSorts.cf" class="advanced-sort-select" @change="onSortChange('cf')">
									<option v-for="opt in sortOptions" :key="'cf-' + opt.value" :value="opt.value">{{ opt.label }}</option>
								</select>
							</div>
							<div class="advanced-sort-col">
								<label class="advanced-sort-label">Trafic</label>
								<select v-model="advancedSorts.traffic" class="advanced-sort-select" @change="onSortChange('traffic')">
									<option v-for="opt in sortOptions" :key="'traffic-' + opt.value" :value="opt.value">{{ opt.label }}</option>
								</select>
							</div>
							<div class="advanced-sort-col">
								<label class="advanced-sort-label">Score</label>
								<select v-model="advancedSorts.bqs_score" class="advanced-sort-select" @change="onSortChange('bqs_score')">
									<option v-for="opt in sortOptions" :key="'score-' + opt.value" :value="opt.value">{{ opt.label }}</option>
								</select>
							</div>
						</div>
					</div>
				</transition>
			</div>

			<div>
				<div v-if="loading"><circular-loader /></div>
				<div v-else>
					<BacklinksTable
						ref="backlinksTable"
						class="mt-5"
						:dataList="dataList"
						:columns="columns"
						:subColPaperClub="subColPaperClub"
						:subColRocketlinks="subColRocketlinks"
					/>
					<vs-pagination
						class="mt-5"
						:total="totalPage"
						v-model="currentx"
					></vs-pagination>
				</div>
				<!-- <vs-tab label="Favori">
					<div v-if="loading">Loading ...</div>
					<div v-else>
						<BacklinksTable
							ref="backlinksTable"
							:dataList="dataList"
							:columns="columns"
							:subColPaperClub="subColPaperClub"
							:subColRocketlinks="subColRocketlinks"
						/>
						<vs-pagination
							class="mt-5"
							:total="totalPage"
							v-model="currentx"
						></vs-pagination>
					</div>
				</vs-tab>
				<vs-tab label="Shortlist">
					<div v-if="loading">Loading ...</div>
					<div v-else>
						<BacklinksTable
							ref="backlinksTable"
							:dataList="dataList"
							:columns="columns"
							:subColPaperClub="subColPaperClub"
							:subColRocketlinks="subColRocketlinks"
						/>
						<vs-pagination
							class="mt-5"
							:total="totalPage"
							v-model="currentx"
						></vs-pagination>
					</div>
				</vs-tab> -->
			</div>
		</div>
	</div>
</template>
<script>
import { Backlinks } from "@/entities/Backlinks.js";
import FilterCard from "@/views/filters/FilterCard";
import BacklinksTable from "@/components/tables/BacklinksTable.vue";
import XLSX from "xlsx";
import CircularLoader from "../../components/widgets/loader/CircularLoader.vue";
// const columns = Backlinks.getFields();
const columns = Backlinks.getColumns();
const subColPaperClub = Backlinks.getSubColumnsPaperClub();
const subColRocketlinks = Backlinks.getSubColumnsRocketLinks();
const data = [];
export default {
	components: {
		FilterCard,
		BacklinksTable,
		CircularLoader,
	},
	props: {
		thematic: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			data,
			columns,
			subColPaperClub,
			subColRocketlinks,
			currentx: 1,
			postBody: {},
			totalPage: 1,
			dataList: [],
			loading: false,
			currentTab: 0,
			backlinkLinkKey: 0,
			siteFilter: null,
			categoryFilter: "",
			countryFilter: "",
			sortType: null,
			startPriceFilter: "",
			endPriceFilter: "",
			filterRefreshKey: 0,
			exportButtonKey: 0,
			paperQuerySearch: "",
			rocketQuerySearch: "",
			showResults: false,
			selectedThematics: [],
			categories: [],
			selectedCountries: [],
			countries: [],
			actionsTemplates: [
				{
					order: 9,
					emitSlugName: "export_btn",
					value: true,
					buttonName: "Exporter",
					type: "Btn",
				},
			],
			filtersTemplates: [
				// {
				// 	order: 1, // Filter order compared to others
				// 	emitSlugName: "site_link",
				// 	filterPlaceHolder: "Site",
				// 	value: "", // Consultant id
				// 	type: "Input",
				// },
				// {
				// 	order: 2,
				// 	emitSlugName: "category",
				// 	filterPlaceHolder: "Thema",
				// 	value: "",
				// 	type: "Input",
				// }, {
				// 	order: 3,
				// 	emitSlugName: "filter_delivery",
				// 	filterPlaceHolder: "Prestation",
				// 	value: "",
				// 	type: "Dropdown",
				// 	params: {
				// 		autocomplete: true,
				// 		dropdownValues: [
				// 			{name: "SEO", id: 1},
				// 			{name: "SEA", id: 2},
				// 			{name: "E-Réputation", id: 3},
				// 			{name: "Social Ads", id: 4},
				// 			{name: "RP Digitale", id: 5},
				// 			{name: "Formation", id: 6},
				// 			{name: "Autre", id: 7},
				// 		]
				// 	}
				// }, {
				// 	order: 4,
				// 	emitSlugName: "filter_type",
				// 	filterPlaceHolder: "Type",
				// 	value: "",
				// 	type: "Dropdown",
				// 	params: {
				// 		autocomplete: true,
				// 		dropdownValues: [
				// 		/*
				// 		 *  {name: "Mensuel", id: 1},
				// 		 *  	{name: "One Shot", id: 0}
				// 		 * add one to avoid collision of value 0 with defaut
				// 		 */

				/*
				 * 			{name: "Mensuel", id: 2},
				 * 			{name: "One Shot", id: 1}
				 * 		]
				 * 	}
				 * },
				 */
				{
					order: 5,
					emitSlugName: "filter_category",
					filterPlaceHolder: "Thématique",
					value: "",
					type: "PaperClubDropdown",
					params: {
						autocomplete: true,
						multiple: true,
						dropdownValues: [],
					},
				},
				{
					order: 6,
					emitSlugName: "filter_country",
					filterPlaceHolder: "Pays",
					value: "",
					type: "PaperClubDropdown",
					params: {
						autocomplete: true,
						multiple: true,
						dropdownValues: [],
					},
				},
				{
					order: 7, // Filter order compared to others
					emitSlugName: "start_price",
					filterPlaceHolder: "Prix minimum (€)",
					value: "", // Minimum price
					type: "Input",
				},
				{
					order: 8, // Filter order compared to others
					emitSlugName: "end_price",
					filterPlaceHolder: "Prix maximum (€)",
					value: "", // Maximum price
					type: "Input",
				},

				/*
				 * {
				 * 	order: 6,
				 * 	emitSlugName: "filter_commercial",
				 * 	filterPlaceHolder: "Commercial",
				 * 	value: "",
				 * 	type: "Dropdown",
				 * 	params: {
				 * 		autocomplete: true,
				 * 		multiple: false,
				 * 		dropdownValues: []
				 * 	}
				 * }, {
				 * 	order: 7,
				 * 	emitSlugName: "filter_consultant",
				 * 	filterPlaceHolder: "Consultant Lead",
				 * 	value: "",
				 * 	type: "Dropdown",
				 * 	params: {
				 * 		autocomplete: true,
				 * 		multiple: false,
				 * 		dropdownValues: []
				 * 	}
				 * },
				 */
				{
					order: 8,
					emitSlugName: "filter_btn",
					value: true,
					type: "Btn",
				},
				// {
				// 	order: 10,
				// 	emitSlugName: "sort_btn",
				// 	value: true,
				// 	type: "BacklinkSort",
				// },
			],
			runFilter: 0,
			showAdvancedFilters: false,
			advancedSorts: {
				tf: "relevant",
				cf: "relevant",
				traffic: "relevant",
				bqs_score: "relevant",
			},
			sortOptions: [
				{ label: "Relevant", value: "relevant" },
				{ label: "Croissant (+)", value: "asc" },
				{ label: "Décroissant (-)", value: "desc" },
			],
		};
	},
	watch: {
		$route: {
			immediate: true,
			handler(to, from) {
				// Handle route changes
				if (to.params.thematic) {
					// We're on the results page - thematics are comma-separated in URL
					const thematicsString = decodeURIComponent(to.params.thematic);
					this.selectedThematics = thematicsString.split(",");
					this.showResults = true;

					// Resolve IDs to category names for the API
					let catNames = [];
					let catIds = [];
					this.selectedThematics.forEach((ele) => {
						const cat = this.categories.find((c) => String(c.id) === String(ele));
						if (cat) {
							catNames.push(cat.name);
							catIds.push(cat.id);
						}
					});
					this.categoryFilter = catNames;
					this.postBody["category"] = catNames;
					this.postBody["categories_ids"] = catIds;

					// Handle price range from query parameters
					if (to.query.start_price) {
						this.startPriceFilter = to.query.start_price;
						this.postBody["start_price"] = this.startPriceFilter;
						// Update filter template value
						const startPriceFilter = this.filtersTemplates.find(
							(ele) => ele.emitSlugName === "start_price"
						);
						if (startPriceFilter) {
							startPriceFilter.value = this.startPriceFilter;
						}
					}
					if (to.query.end_price) {
						this.endPriceFilter = to.query.end_price;
						this.postBody["end_price"] = this.endPriceFilter;
						// Update filter template value
						const endPriceFilter = this.filtersTemplates.find(
							(ele) => ele.emitSlugName === "end_price"
						);
						if (endPriceFilter) {
							endPriceFilter.value = this.endPriceFilter;
						}
					}

					// Handle countries from query parameters
					if (to.query.countries) {
						const countriesString = to.query.countries;
						// Split by comma to get country names
						this.selectedCountries = countriesString.split(",");
						this.countryFilter = this.selectedCountries;
						this.postBody["countries"] = this.selectedCountries;
						// Update filter template value
						const countryFilter = this.filtersTemplates.find(
							(ele) => ele.emitSlugName === "filter_country"
						);
						if (countryFilter) {
							countryFilter.value = this.selectedCountries;
						}
					}

					// Fetch backlinks with the thematics and price range
					this.fetchBacklinks(1, this.postBody);

					// Update the filter to show the selected thematics
					const categoryFilter = this.filtersTemplates.find(
						(ele) => ele.emitSlugName === "filter_category"
					);
					if (categoryFilter) {
						categoryFilter.value = catNames;
					}
				} else if (to.name === "backlinks-repertoire") {
					// We're on the selection page
					this.showResults = false;
					this.selectedThematics = [];
					this.selectedCountries = [];
					this.dataList = [];
					this.postBody = {};
					this.startPriceFilter = "";
					this.endPriceFilter = "";
					this.countryFilter = "";
				}
			},
		},
		exportButtonKey: function () {
			this.exportToExcel(this.dataList);
		},
		currentx: function (data) {
			this.fetchBacklinks(data, this.postBody);
		},
		sortType: function (data) {
			(this.postBody["sort_type"] = data),
				this.fetchBacklinks(this.currentx, this.postBody);
		},
		runFilter: function () {
			this.filterBacklinks();
		},
		currentTab: function () {
			this.fetchBacklinks(this.currentx, this.postBody);
		},
	},

	created() {
		// Fetch categories and countries, route watcher will handle the rest
		this.fetchCategories();
		this.fetchCountries();
	},

	methods: {
		fetchCategories() {
			this.$http
				.get("backlinks/categories")
				.then((res) => {
					if (res.data && res.data.data) {
						// Store categories for the initial selection
						this.categories = res.data.data.map((cat) => ({
							id: cat.id,
							name: cat.category,
						}));

						// Also update the filter dropdown
						const categoryFilter = this.filtersTemplates.find(
							(ele) => ele.emitSlugName === "filter_category"
						);
						if (categoryFilter) {
							categoryFilter.params.dropdownValues = this.categories;
							this.filterRefreshKey++;
						}

						// Re-resolve selected thematics now that categories are loaded
						if (this.selectedThematics && this.selectedThematics.length > 0 && this.showResults) {
							let catNames = [];
							let catIds = [];
							this.selectedThematics.forEach((ele) => {
								const cat = this.categories.find((c) => String(c.id) === String(ele));
								if (cat) {
									catNames.push(cat.name);
									catIds.push(cat.id);
								}
							});
							this.categoryFilter = catNames;
							this.postBody["category"] = catNames;
							this.postBody["categories_ids"] = catIds;
							const catFilter = this.filtersTemplates.find(
								(ele) => ele.emitSlugName === "filter_category"
							);
							if (catFilter) {
								catFilter.value = catNames;
							}
							this.fetchBacklinks(1, this.postBody);
						}
					}
				})
				.catch((err) => {
					console.error("Error fetching categories:", err);
					this.$vs.notify({
						title: "Erreur",
						text: "Impossible de charger les catégories",
						color: "danger",
					});
				});
		},

		fetchCountries() {
			this.$http
				.get("countries/all")
				.then((res) => {
					if (res.data) {
						// Store countries for the initial selection
						// Using fr_fr_name as both the value and display name
						this.countries = res.data.map((country) => ({
							id: country.fr_fr_name || country.name,
							name: country.fr_fr_name || country.name,
						}));

						// Also update the filter dropdown for countries
						const countryFilter = this.filtersTemplates.find(
							(ele) => ele.emitSlugName === "filter_country"
						);
						if (countryFilter) {
							countryFilter.params.dropdownValues = this.countries;
							this.filterRefreshKey++;
						}
					}
				})
				.catch((err) => {
					console.error("Error fetching countries:", err);
					this.$vs.notify({
						title: "Erreur",
						text: "Impossible de charger les pays",
						color: "danger",
					});
				});
		},

		searchWithThematic() {
			if (!this.selectedThematics || this.selectedThematics.length === 0)
				return;

			// Join multiple thematics with comma and navigate to results URL
			const thematicsString = this.selectedThematics.join(",");

			// Build query parameters for price range and countries
			const queryParams = {};
			if (this.startPriceFilter) {
				queryParams.start_price = this.startPriceFilter;
			}
			if (this.endPriceFilter) {
				queryParams.end_price = this.endPriceFilter;
			}
			if (this.selectedCountries && this.selectedCountries.length > 0) {
				// Join country names with comma for URL
				queryParams.countries = this.selectedCountries.join(",");
			}

			this.$router.push({
				name: "backlinks-repertoire-results",
				params: { thematic: encodeURIComponent(thematicsString) },
				query: queryParams,
			});
		},

		onSortChange(changedField) {
			// Reset all other sorts to "relevant" — only one sort active at a time
			const allFields = ["tf", "cf", "traffic", "bqs_score"];
			allFields.forEach((field) => {
				if (field !== changedField) {
					this.advancedSorts[field] = "relevant";
				}
			});
			// Clean all sort keys from postBody, then add only the active one
			delete this.postBody["sort_tf"];
			delete this.postBody["sort_cf"];
			delete this.postBody["sort_traffic"];
			delete this.postBody["sort_bqs_score"];
			const bodyKeyMap = { tf: "sort_tf", cf: "sort_cf", traffic: "sort_traffic", bqs_score: "sort_bqs_score" };
			if (this.advancedSorts[changedField] !== "relevant") {
				this.postBody[bodyKeyMap[changedField]] = this.advancedSorts[changedField];
			}
			this.currentx = 1;
			this.fetchBacklinks(1, this.postBody);
		},
		closeAdvancedFilters() {
			this.showAdvancedFilters = false;
			this.advancedSorts = { tf: "relevant", cf: "relevant", traffic: "relevant", bqs_score: "relevant" };
		},
		resetSearch() {
			// Navigate back to the selection page
			this.$router.push({ name: "backlinks-repertoire" });
		},

		getThematicName(thematicId) {
			const thematic = this.categories.find((cat) => String(cat.id) === String(thematicId));
			return thematic ? thematic.name : thematicId;
		},
		fetchBacklinks(page, body = {}) {
			this.loading = true;
			let url = `backlinks/getAll?page=${page}&limit=100`;
			if (this.currentTab == 1)
				url = `backlinks/save/getAllByOffset?page=${page}&limit=100`;
			else if (this.currentTab == 2)
				url = `backlinks/shortlist/getAllByOffset?page=${page}&limit=100`;
			this.$http
				.post(url, body)
				.then((res) => {
					this.dataList = (res.data.dataList || []).map((item) => {
						const row = { ...item };
						// Map categories to category for table display
						if (row.categories) row.category = row.categories;
						// Parse providers JSON and flatten provider data
						if (row.providers && typeof row.providers === "string") {
							try {
								const providers = JSON.parse(row.providers);
								if (providers && providers.length > 0) {
									const p = providers[0];
									row.articles_price = p.articles_price;
									row.traffic = p.traffic;
									row.tf = p.tf;
									row.cf = p.cf;
									row.domain_ref = p.domain_ref;
									row.keywords = p.keywords;
									row.bqs_score = p.bqs_score;
									row.bl = p.bl;
									row.domainRating = p.domainRating;
									// Find Rocketlinks provider and map its price
									for (let i = 0; i < providers.length; i++) {
										const prov = providers[i];
										if (prov.rock_price_redaction) {
											row.articles_price_1 = prov.rock_price_redaction;
											break;
										}
										if (prov.list_provider === "Rocketlinks" || prov.provider === "Rocketlinks" || prov.source === "Rocketlinks") {
											row.articles_price_1 = prov.articles_price;
											break;
										}
									}
									// Fallback: if 2 providers, second one is Rocketlinks
									if (!row.articles_price_1 && providers.length > 1) {
										row.articles_price_1 = providers[1].articles_price || providers[1].rock_price_redaction;
									}
								}
							} catch (e) {
								// ignore parse errors
							}
						}
						return row;
					});
					this.totalPage = res.data.total_page;
					this.loading = false;
				})
				.catch((err) => {
					this.loading = false;
					console.error(err);
				});
		},
		fetchHostingCountries() {
			this.loading = true;
			let url = "backlinks/get_hosting_countries";
			this.$http
				.get(url)
				.then((res) => {
					this.filtersTemplates.forEach((ele) => {
						if (ele.emitSlugName == "filter_country") {
							ele.params.dropdownValues = res.data;
						}
					});
					this.filterRefreshKey++;
				})
				.catch((err) => {
					this.loading = false;
					console.error(err);
				});
		},
		resetAllFilter() {
			// Clear all filters except the thematic selection (categoryFilter) and countries (countryFilter)
			this.siteFilter = null;
			// Keep categoryFilter (thematics) and countryFilter unchanged
			this.paperQuerySearch = "";
			this.rocketQuerySearch = "";
			this.startPriceFilter = "";
			this.endPriceFilter = "";
			this.advancedSorts = { tf: "relevant", cf: "relevant", traffic: "relevant", bqs_score: "relevant" };
			this.page = 1;
			this.runFilter++;

			// Reset filter template values (except category and country)
			this.filtersTemplates.forEach((filter) => {
				if (filter.emitSlugName !== "filter_category" && filter.emitSlugName !== "filter_country") {
					filter.value = "";
				}
			});

			// Rebuild postBody with thematics and countries preserved
			this.postBody = {};
			if (this.categoryFilter && this.categoryFilter.length > 0) {
				let catIds = [];
				this.categoryFilter.forEach((ele) => {
					const cat = this.categories.find((c) => c.name === ele);
					if (cat) catIds.push(cat.id);
				});
				this.postBody["category"] = this.categoryFilter;
				this.postBody["categories_ids"] = catIds;
			}
			if (this.countryFilter && this.countryFilter.length > 0) {
				this.postBody["countries"] = this.countryFilter;
			}

			// Refresh the data with thematics and countries filters
			this.fetchBacklinks(1, this.postBody);
		},
		exportToExcel(data) {
			const jsonData = data;

			// Convert the data to Excel format
			const worksheet = XLSX.utils.json_to_sheet(jsonData);

			// Create a new workbook and add the worksheet to it
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

			// Define the filename for the Excel file
			const fileName = "Backlinks.xlsx";

			// Generate the Excel file and trigger the download
			XLSX.writeFile(workbook, fileName);
		},
		filterBacklinks() {
			this.postBody = {};
			this.paperQuerySearch = "";
			this.rocketQuerySearch = "";
			if (this.siteFilter) {
				this.postBody["name"] = this.siteFilter;
			}
			if (this.categoryFilter != "") {
				let listCatIds = [];
				this.categoryFilter.forEach((ele) => {
					const cat = this.categories.find((c) => c.name === ele);
					if (cat) listCatIds.push(cat.id);
				});
				this.postBody["category"] = this.categoryFilter;
				this.postBody["categories_ids"] = listCatIds;
			}
			if (this.countryFilter != "") {
				let listCat = [];
				this.countryFilter.forEach((ele) => {
					listCat.push(ele);
				});
				this.postBody["countries"] = listCat;
			}
			if (this.startPriceFilter != "") {
				this.postBody["start_price"] = this.startPriceFilter;
			}
			if (this.endPriceFilter != "") {
				this.postBody["end_price"] = this.endPriceFilter;
			}
			// Apply active advanced sorts to postBody
			const sortKeys = { tf: "sort_tf", cf: "sort_cf", traffic: "sort_traffic", bqs_score: "sort_bqs_score" };
			for (const [field, bodyKey] of Object.entries(sortKeys)) {
				if (this.advancedSorts[field] !== "relevant") {
					this.postBody[bodyKey] = this.advancedSorts[field];
				} else {
					delete this.postBody[bodyKey];
				}
			}
			this.currentx = 1;
			this.fetchBacklinks(this.currentx, this.postBody);
		},
		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit) {
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == receivedEmit[0]
			);
			if (templateRowIndex >= 0)
				this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch (receivedEmit[0]) {
				case "site_link":
					this.siteFilter = receivedEmit[1].value;
					break;
				case "filter_contract":
					this.contractNumberFilter = receivedEmit[1].value;
					break;
				case "filter_delivery":
					this.deliveryFilter = receivedEmit[1].value;
					break;
				case "filter_type":
					this.typeFilter = receivedEmit[1].value;
					break;
				case "filter_category":
					this.categoryFilter = receivedEmit[1].value;
					break;
				case "filter_country":
					this.countryFilter = receivedEmit[1].value;
					break;
				case "start_price":
					this.startPriceFilter = receivedEmit[1].value;
					break;
				case "end_price":
					this.endPriceFilter = receivedEmit[1].value;
					break;
				case "filter_commercial":
					this.commercialFilter = receivedEmit[1].value;
					break;
				case "filter_consultant":
					this.accountmanagerFilter = receivedEmit[1].value;
					break;
				case "sort_btn":
					this.sortType = receivedEmit[1].value;
					break;
				case "filter_btn":
					this.runFilter++;
					break;
				case "export_btn":
					this.exportButtonKey++;
					break;
				default:
					break;
			}
		},
	},
};
</script>
<style>
.highlight-bottom-border > td {
	border-bottom: solid 1px black !important;
}

.highlight-top-border > td {
	border-top: solid 2px black !important;
	border-bottom: solid 2px #6d9eff !important;
}

#backlink-down-row {
	background-color: #f8f8f8;
}
.sorter-no-tooltip .ant-table-column-sorters:before {
	content: none !important;
}

/* Unified filter card: remove FilterCard's own card shadow/margin */
.backlinks-filter-wrapper #fliterCard {
	box-shadow: none !important;
	margin-bottom: 0 !important;
	border-bottom-left-radius: 0 !important;
	border-bottom-right-radius: 0 !important;
}

.backlinks-filter-wrapper {
	background: white;
	border-radius: 0.5rem;
	box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
	margin-bottom: 0.25rem;
	overflow: hidden;
}

.advanced-filters-bar {
	display: flex;
	justify-content: flex-end;
	padding: 0 1rem 0.5rem 1rem;
}

.advanced-filters-toggle {
	font-size: 0.9rem;
	font-weight: 600;
	color: rgba(var(--vs-primary), 1);
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	user-select: none;
}
.advanced-filters-toggle:hover {
	opacity: 0.8;
}

.advanced-filters-panel {
	padding: 0.5rem 1.5rem 1rem 1.5rem;
	border-top: 1px solid #f0f0f0;
}

.advanced-sorts-row {
	display: flex;
	gap: 6px;
	max-width: 35%;
	margin-left: auto;
}

.advanced-sort-col {
	flex: 1;
	min-width: 0;
}

.advanced-sort-label {
	display: block;
	font-size: 0.8rem;
	color: #626262;
	margin-bottom: 2px;
}

.advanced-sort-select {
	width: 100%;
	padding: 4px 6px;
	font-size: 0.7rem;
	border: 1px solid #d9d9d9;
	border-radius: 4px;
	background: white;
	color: #626262;
	outline: none;
	cursor: pointer;
}
.advanced-sort-select:focus {
	border-color: #7367f0;
}

.advanced-filters-slide-enter-active,
.advanced-filters-slide-leave-active {
	transition: all 0.3s ease;
	max-height: 300px;
	overflow: hidden;
}

.advanced-filters-slide-enter,
.advanced-filters-slide-leave-to {
	max-height: 0;
	opacity: 0;
	padding-top: 0;
	padding-bottom: 0;
	overflow: hidden;
}
</style>

